import React from 'react'
import AllComponents from './components/AllComponents'
import { CartProvider, useCart } from 'react-use-cart'

function ProductCart() {
  const { items, updateItemQuantity, removeItem, cartTotal, totalItems, isEmpty } = useCart()
  if (isEmpty) {
    return (
      <div className='row'>

        <div className='col-md-6 m-auto text-center mt-5'><img src="/assets/images/empty-card-shopping.png" style={{ width: '300px' }} alt="" /></div>
        <h3 className='my-4 text-center'>Your Cart Is Empty...</h3>
      </div>
    )
  } else {
    return (
      <div>


        <main className="page">
          <section className="shopping-cart dark">
            <div className="container-fluid">
              <div className="block-heading">
                <h2>Shopping Cart</h2>
              </div>
              <div className="content">
                <div className="row">
                  <div className="col-md-12 col-lg-8">
                    <div className="items">


                      {items.map((product) => {
                        return (
                          <div className="product">
                            <div className="row">
                              <div className="col-md-3">
                                <img
                                  className="img-fluid mx-auto d-block image"
                                  src={product.image}
                                />
                              </div>
                              <div className="col-md-8">
                                <div className="info">
                                  <div className="row">
                                    <div className="col-md-5 product-name">
                                      <div className="product-name">
                                        <h5 className='orange mt-4'>{product.name}</h5>
                                        <div className="product-info">
                                          <div>
                                            Location: <span className="value">{product.location}</span>
                                          </div>
                                          <div>
                                            Bedrooms: <span className="value">{product.bedrooms}</span>
                                          </div>
                                          <div>
                                            Rating: <span className="value">{product.rating}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4 quantity">
                                      <label htmlFor="quantity">Quantity:</label>
                                      <h5 className='mt-2 mb-3 '>{product.quantity}</h5>
                                      <button className=' btn btn-warning orangebtn' onClick={() => updateItemQuantity(product.id, product.quantity - 1)}><i class="fa-solid fa-minus"></i></button>
                                      <button className='  btn btn-warning d-inline-block mx-2 orangebtn ' onClick={() => updateItemQuantity(product.id, product.quantity + 1)}><i class="fa-solid fa-plus"></i></button>
                                      <button className='btn btn-warning orangebtn' onClick={() => removeItem(product.id)}>
                                        <i class="fa-solid fa-xmark"></i></button >
                                    </div>
                                    <div className="col-md-3 price">
                                      <span>${Math.round(product.price * product.quantity)}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}



                    </div>
                  </div>
                  <div className="col-md-12 col-lg-4">
                    <div className="summary">
                      <h3>Summary</h3>
                      <div className="summary-item">
                        <span className="text">Subtotal</span>
                        <span className="price">${Math.round(cartTotal)}</span>
                      </div>
                      <div className="summary-item">
                        <span className="text">Quantity</span>
                        <span className="price">{totalItems}</span>
                      </div>
                      <div className="summary-item">
                        <span className="text">Shipping</span>
                        <span className="price">$3000</span>
                      </div>
                      <div className="summary-item">
                        <span className="text">Total</span>
                        <span className="price">${Math.round(cartTotal + 3000)}</span>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary orangebtn btn-lg d-block mx-auto"
                      >
                        Checkout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

      </div >
    )
  }
}

function Cart() {


  return (
    <CartProvider>
      <AllComponents />
      <ProductCart />

    </CartProvider>
  )
}

export default Cart;